export default __webpack_public_path__ + "static/media/Home-Hero-Desktop.5b165fcb.jpg";